import MailList from './MailList'

export default MailList;